/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import UnitConversions from "../../components/UnitConversions";

const AdminUnitConversions = (props) => {
    return (
        <UnitConversions moduleType={'Admin'} {...props} />
    )
}

export default AdminUnitConversions